"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class PaymentMethod {
    static fromObj(data) {
        if ((data === null || data === void 0 ? void 0 : data.type) === __1.ePaymentMethodType.BILL_TO_INVOICE) {
            return new __1.BillToInvoice();
        }
        if ((data === null || data === void 0 ? void 0 : data.type) === __1.ePaymentMethodType.PAYHAWK_NEW_CC) {
            const { paymentToken, cardHolderName, store, setAsDefault } = data;
            return new __1.PayhawkNewCC(paymentToken, cardHolderName, store, setAsDefault);
        }
        if ((data === null || data === void 0 ? void 0 : data.type) === __1.ePaymentMethodType.PAYHAWK_STORED_CC) {
            return __1.PayhawkStoredCC.fromObj(data);
        }
        if ((data === null || data === void 0 ? void 0 : data.type) === __1.ePaymentMethodType.PAYFABRIC_CC) {
            return new __1.PayfabricCC();
        }
        if ((data === null || data === void 0 ? void 0 : data.type) === __1.ePaymentMethodType.STRIPE_CC) {
            return __1.StripeCC.fromObj(data);
        }
        return undefined;
    }
}
exports.default = PaymentMethod;
//# sourceMappingURL=paymentMethod.class.js.map